import React, { useContext } from 'react'
import {
    Stack,
    Box,
    Typography
} from '@mui/material'

import { AppContext } from './../../context/context/context.js'

import youssef from './../../assets/youssef.png'
import data from '../../data/portfolio.json'

import './home.css'

const Home = () => {
    const { state } = useContext(AppContext)

    return (
        <Box
            data-aos="fade-up"
            data-aos-anchor-placement="top-bottom"
            width={{ xs: '100%' }}
            position="relative"
            mt={5}
            overflow={"hidden"}
        >
            <div className="custom-shape-divider-top-1712416385">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" className="shape-fill"></path>
                </svg>
            </div>
            <Stack
                direction={{ xs: 'row' }}
                alignItems="center"
                py={{ xs: 15 }}
                bgcolor="#C9C7C6"
                width={'100%'}
            >
                <Stack
                    justifyContent="flex-end"
                    alignItems="center"
                    width={'45%'}
                >
                    <Typography
                        variant="h2"
                        zIndex={100}
                        sx={{
                            color: state.color.active,
                            fontWeight: 900,
                            fontSize: { xs: 30, md: 64 },
                            transform: { xs: 'scaleY(2.5) scaleX(0.9)', md: 'scaleY(3.1) scaleX(0.85)' },
                        }}
                    >
                        {data.name.split(' ')[0]}
                    </Typography>
                    <Typography
                        variant="h2"
                        zIndex={100}
                        py={{ xs: 2.5, md: 7 }}
                        sx={{
                            color: state.color.dark,
                            fontWeight: 900,
                            fontSize: { xs: 20, md: 44 },
                            transform: { xs: 'scaleY(2) scaleX(0.95)', md: 'scaleY(2.3) scaleX(0.86)' },
                        }}
                    >
                        {data.name.split(' ')[1]}
                    </Typography>
                    <Typography
                        variant="h4"
                        zIndex={100}
                        gutterBottom
                        my={1}
                        sx={{
                            color: state.color.active,
                            fontWeight: 700,
                            fontSize: { xs: 14, sm: 18, md: 24 },
                            transform: { xs: 'scaleY(1.2)', md: 'scaleY(1.9)' },
                        }}
                    >
                        {data.subtitle}
                    </Typography>
                </Stack>
                <Box
                    component='img'
                    alt="Youssef Mohammed"
                    src={youssef}
                    zIndex={10}
                    height={{ xs: "75%" }}
                    sx={{
                        position: "absolute",
                        right: "20%",
                        top: 80,
                    }}
                />
            </Stack>
            <div className="custom-shape-divider-bottom-1712416673">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" className="shape-fill"></path>
                </svg>
            </div>
        </Box >
    )
}

export default Home
